import { render, staticRenderFns } from "./addressbook.vue?vue&type=template&id=42541ecf"
import script from "./addressbook.vue?vue&type=script&lang=js"
export * from "./addressbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports